import { ApiClient } from '@memoraiz/api-client';

function createResource<T>(factory: (client: ApiClient) => T) {
  return (client: ApiClient) => factory(client);
}

export const SdkResource = {
  from: createResource,
};
